module.exports = __webpack_public_path__ + "img/merci-youpaq-bg.77e6ee91.svg";